import React from 'react';
import styles from './L1TradeRiskFilter.module.scss';
import { Button } from '../../components/Button';
import { Label } from '../../components/Label';
import PropTypes from 'prop-types';
import { TextBox } from 'devextreme-react';

const styleAttributes = {
  class: styles.inputMobile
};
class L1TradeRiskFilter extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      senderMpids: '',
      receiverMpids: ''
    };
    // preserve the initial state in a new object
    this.baseState = this.state;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleChange (event, name) {
    //  console.log(event.value);
    //  console.log(name);
    this.setState({
      [name]: event.value
    });
  }

  handleSearch () {
    this.handleSubmit('search');
  }

  handleSubmit (type) {
    let queryParam = this.state;
    this.props.search(queryParam, type);
  }

  handleKeyDown (e) {
    if (e.key === 'Enter') {
      this.handleSubmit('search');
    };
  }

  render () {
    return (
      <div id='L1TradeRiskFilter' className={styles.container}>
        <div className={styles.formContainer}>

          <div className={styles.riskFilterGridStyle} onKeyDown={this.handleKeyDown}>

            <div key={'senderMpidKey'}>
              <Label title='Sender MPID' />
              <TextBox
                name={'senderMpids'} placeholder={'Sender MPID'} value={this.state['senderMpids']} showClearButton
                valueChangeEvent='keyup'
                inputAttr={styleAttributes}
                onValueChanged={(e) => this.handleChange(e, 'senderMpids')} />

            </div>
            <div key={'receiverMpidKey'}>
              <Label title='Receiver MPID' />
              <TextBox
                name={'receiverMpids'} placeholder={'Receiver MPID'} value={this.state['receiverMpids']} showClearButton
                valueChangeEvent='keyup'
                inputAttr={styleAttributes}
                onValueChanged={(e) => this.handleChange(e, 'receiverMpids')} />

            </div>
            <div id='applyButtonDiv' className={styles.applyButton}> <Button title='Apply' onClick={this.handleSearch} size='extraSmall' /></div>

          </div>

        </div>
      </div>
    );
  }
}
export default L1TradeRiskFilter;

L1TradeRiskFilter.propTypes = {
  search: PropTypes.func
};
